// extracted by mini-css-extract-plugin
export default {"appLayout":"riIqAqBrXEIGpnfwoNXb","mainContent":"WQDTMiXXHc9cSzlA0m5Y"};